var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavJobsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6207 2.06898H8.96556C8.96556 2.06898 7.65798 0 6.89658 0H3.4483C2.6869 0 2.069 0.617255 2.069 1.3793V17.2414C2.069 18.0028 2.6869 18.6207 3.4483 18.6207H18.6207C19.3821 18.6207 20 18.0028 20 17.2414V3.44828C20 2.68688 19.3821 2.06898 18.6207 2.06898Z",
    fill: "#FF6A14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.069 4.13788H20V9.65514H2.069V4.13788Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3793 5.51727H20.6897C21.4511 5.51727 22.069 6.13453 22.069 6.89657L20.6897 18.6207C20.6897 19.3821 20.0718 20 19.3104 20H2.7586C1.9972 20 1.3793 19.3821 1.3793 18.6207L0 6.89657C0 6.13446 0.617898 5.51727 1.3793 5.51727Z",
    fill: "#FF6A14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavJobsSelected);
export default __webpack_public_path__ + "static/media/nav_jobs_selected.f82eb74179daacbcc9f043d44eb62446.svg";
export { ForwardRef as ReactComponent };